export function create_esigning_setup_data() {
  return {
    template_id: '',
    template_name: '',
    template_type: '',
    template_bindings: '',
    route_template_entity_type_id: '',
    route_workflow_id: '',
    assigning_form_id: '',
    assigning_workflow_id: '',
    forms_loading: false,
    workflows_loading: false,
    template_form_assignments: {},
    template_entity_type_assignments: [],
    assigned_workflow_binding: null,
    setup_active_tab: 'forms',
    setup_tabs: [
      { key: 'forms', label: 'Forms', icon: 'bi-ui-checks-grid' },
      { key: 'workflows', label: 'Workflows', icon: 'bi-diagram-3' },
      { key: 'configure', label: 'Configure Template', icon: 'bi-bounding-box-circles' },
    ],
    template_forms: [],
    workflows: [],
    selected_form_id: '',
    selected_workflow_id: '',
  };
}

export function normalize_template_form(form) {
  if (!form || typeof form !== 'object') return null;
  if (!form.template_form_id) return null;

  return {
    id: String(form.template_form_id),
    name: String(form.form_name || 'Untitled Form').trim(),
    description: String(form.form_description || 'Used for template onboarding mapping.').trim(),
    onboarding_form: 'Not linked',
    onboarding_form_id: '',
    raw: form,
  };
}

export function normalize_workflow_step(step) {
  if (!step || typeof step !== 'object') return null;

  return {
    id: step.id || null,
    order: Number(step.order || 0) || 0,
    entity_type_id: Number(step.entity_type_id || 0) || null,
    entity_type_name: String(step.entity_type_name || '').trim(),
    expected_signer_count: Number(step.expected_signer_count || 0) || 0,
  };
}

export function normalize_workflow(workflow) {
  if (!workflow || typeof workflow !== 'object' || !workflow.id) return null;

  const steps = (Array.isArray(workflow.steps) ? workflow.steps : [])
    .map(normalize_workflow_step)
    .filter(Boolean);

  return {
    id: String(workflow.id),
    name: String(workflow.name || '').trim() || 'Untitled Workflow',
    description: String(workflow.description || '').trim(),
    created_at: workflow.created_at || null,
    steps,
    step_count: Number(workflow.step_count || steps.length || 0) || 0,
    total_expected_signers: Number(workflow.total_expected_signers || 0) || 0,
    assigned_templates: Array.isArray(workflow.assigned_templates)
      ? workflow.assigned_templates
      : [],
    assigned_template_count: Number(
      workflow.assigned_template_count ||
      (Array.isArray(workflow.assigned_templates) ? workflow.assigned_templates.length : 0) ||
      0,
    ) || 0,
    is_assigned: Boolean(workflow.is_assigned),
    entity_type: steps.map((step) => step.entity_type_name).filter(Boolean).join(', '),
  };
}

export function normalize_identifier(value) {
  if (value == null) return '';

  if (typeof value === 'object') {
    return String(
      value.id ||
      value.workflow_id ||
      value.template_document_entity_type_id ||
      value.template_entity_type_id ||
      '',
    ).trim();
  }

  return String(value).trim();
}

export function extract_workflow_identifier(source = {}) {
  if (!source || typeof source !== 'object') {
    return '';
  }

  return normalize_identifier(
    source.workflow_id ||
    source.assigned_workflow_id ||
    source.workflow ||
    source.workflow_binding_id,
  );
}

export function extract_template_entity_type_identifier(source = {}) {
  if (!source || typeof source !== 'object') {
    return '';
  }

  return normalize_identifier(
    source.template_document_entity_type_id ||
    source.template_entity_type_id ||
    source.template_document_entity_type ||
    source.id,
  );
}

export function resolve_template_identifier(item = {}) {
  return Number(
    item?.template_id ||
    item?.template_document_id ||
    item?.template ||
    item?.template_document ||
    0,
  ) || 0;
}
